export const extractVideoId = (youtubeLink) => {
    const segments = youtubeLink.split('v=');
    return segments[segments.length - 1];
};
